import React, { Component } from 'react'
import { connect } from 'react-redux'

import { req_list_eps_openCourse } from '../../api'

import { Card, Table, Alert } from 'antd'

class TeacherOpenCourse extends Component {

    state = {
        loading: false,
        deviceWidth: 0,
        userLevel: 'NORMAL',
        item: {},
        items: [],
    }

    UNSAFE_componentWillMount() {
        this.api_list_items()
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this))
        this.resize();
        this.init_columns()
    }

    // componentWillUnmount(){
    //     window.removeEventListener("resize", this.resize.bind(this))
    // }

    resize() {
        this.setState({ deviceWidth: window.innerWidth });
    }

    // 遠端數據處理 //////////////////////////////////////////////
    api_list_items = async () => {
        const { userCode, token } = this.props.user
        this.setState({ loading: true, items: [] })
        const result = await req_list_eps_openCourse(userCode, token)
        this.setState({ loading: false })

        //console.log(result)
        if (result.total > 0) {
            const items = result.data
            this.setState({ items })
   
           // console.log(this.state);
        } else {
            const items = []
            this.setState({ items })
        }
    }

    // 數據配置設定 ////////////////////////////////////////////// 
    init_columns = () => {
        this.columns = [
            {
                title: '課程類型',
                dataIndex: 'CourseType',
                width: 70,
                responsive: ['md'],
                render: (field) => {
                    return (
                        <div className='text-center'>
                            <span style={{ fontSize: '1.1em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '開課部別',
                dataIndex: 'Division',
                width: 70,
                responsive: ['md'],
                render: (field) => {
                    return (
                        <div className='text-center'>
                            <span style={{ fontSize: '1.1em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '開課學制',
                dataIndex: 'EducationalSystem',
                width: 70,
                responsive: ['md'],
                render: (field) => {
                    return (
                        <div className='text-center'>
                            <span style={{ fontSize: '1.1em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '開課科系',
                dataIndex: 'MajorDeptment',
                width: 100,
                responsive: ['md'],
                render: (field) => {
                    return (
                        <div>
                            <span style={{ fontSize: '1.2em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '開課名稱',
                dataIndex: 'CourseName',
                width: 100,
                render: (field) => {
                    return (
                        <div>
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '必(選)修',
                dataIndex: 'SelectType',
                width: 50,
                responsive: ['md'],
                render: (field) => {
                    return (
                        <div className='text-center'>
                            <span style={{ fontSize: '1.1em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '開課班級',
                dataIndex: 'CourseClass',
                width: 60,
                responsive: ['md'],
                render: (field) => {
                    return (
                        <div >
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '授課時間',
                dataIndex: 'CourseTime',
                width: 100,
                render: (field) => {
                    return (
                        <div >
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            },
        ]
    }

    /////////////////////////////////////////////////////////////
    render() {
        const { loading, items } = this.state
        const extra = (
            <Alert message="資料來源：教務處課務組" type="info" showIcon/>
        )
        return (
            <Card extra={extra}>
                <Table
                    bordered
                    scroll={{ y: 480 }}
                    loading={loading}
                    rowKey='CourseTime'
                    dataSource={items}
                    pagination={false}
                    columns={this.columns}
                />
            </Card>
        )
    }
}


export default connect(
    state => ({ user: state.user }),
    {}
)(TeacherOpenCourse)